module.exports = {
  "/": {
    "name": "invalid-page",
    "success": {
      "default": [
        "BACKUP_LOADED"
      ]
    }
  },
  "/backup": {
    "name": "backup-page",
    "success": {
      "default": [
        "BACKUP_LOADED"
      ]
    },
    "error": [
      "BACKUP_LOADED_FAILURE"
    ]
  },
  "/:language/doi/confirmation": {
    "name": "doi-confirmation-page",
    "success": {
      "doi confirmation page loaded": [
        "DOI_CONFIRMATION"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/manage": {
    "name": "manage-preferences-page",
    "success": {
      "manage preferences page pre load": [
        "MANAGE_PREFERENCES_PRE_LOAD"
      ],
      "manage preferences page loaded": [
        "MANAGE_PREFERENCES_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/unsubscribe": {
    "name": "unsubscribe-all-page",
    "success": {
      "unsubscribe all page pre load": [
        "UNSUBSCRIBE_ALL_PRE_LOAD"
      ],
      "unsubscribe all page loaded": [
        "UNSUBSCRIBE_ALL_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/:route/confirmation": {
    "name": "confirmation-page",
    "success": {
      "confirmation page loaded": [
        "CONFIRMATION_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/contact/:route": {
    "name": "contact-verify-page",
    "success": {
      "contact verify page loaded": [
        "CONTACT_VERIFY_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  }
};